import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { SectionsService } from '../../../services/sections.service';
import { ButtonComponent } from '@ppl/ui';
import { BaseComponent } from '../../../shared/utils/base.component';
import { CommPreferenceComponent } from '../comm-preference/comm-preference.component';
import { ContactDetailsComponent } from '../contact-details/contact-details.component';
import { ParticipantInformationComponent } from '../participant-information/participant-information.component';
import { ServiceDetailsComponent } from '../service-details/service-details.component';

@Component({
  selector: 'ppl-summary',
  standalone: true,
  imports: [ContactDetailsComponent,
    ParticipantInformationComponent,
    NzCollapseModule,
    CommPreferenceComponent,
    CommonModule,
    NzButtonModule,
    ButtonComponent,
    ServiceDetailsComponent
  ],
  templateUrl: './summary.component.html',
  styleUrl: './summary.component.css'
})
export class SummaryComponent extends BaseComponent implements OnInit {

  constructor(private sectionsService: SectionsService) {
    super()
  }

  ngOnInit(): void {
    const program = JSON.parse(localStorage.getItem("selected_program")!);
    this.data = this.sectionsService.getAllSteps(program.program_code);
  }

  activeKeys: string[] = [];
  allPanelsExpanded = false;

  hideAll() {
    this.activeKeys = [];
  }

  expandAll() {
    this.activeKeys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];
  }

  togglePanel(key: string): void {
    if (this.isPanelActive(key)) {
      this.activeKeys = this.activeKeys.filter(k => k !== key);
    } else {
      this.activeKeys.push(key);
    }
  }

  isPanelActive(key: string): boolean {
    return this.activeKeys.includes(key);
  }

}
